import React, { useContext } from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Avatar, Container, Menu, MenuItem } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import LogoutIcon from '@mui/icons-material/Logout';
import KeyIcon from '@mui/icons-material/Key';
import PersonIcon from '@mui/icons-material/Person';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// Navbar displays navigation links according to the user's role
// and provides logout functionality.

export default function Navbar() {
  const { user, logout } = useContext(AuthContext);
  const location = useLocation();
  const role = user.role;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  // Get first letter of username for avatar
  const getInitial = (username) => {
    return username ? username.charAt(0).toUpperCase() : 'U';
  };

  // Get color based on role
  const getRoleColor = (role) => {
    switch(role) {
      case 'ADMIN': return '#9c27b0';
      case 'SHIPOWNER': return '#2196f3';
      case 'SUPPLIER': return '#4caf50';
      case 'VERIFIER': return '#ff9800';
      default: return '#607d8b';
    }
  };

  return (
    <AppBar position="static" sx={{ boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', backgroundColor: 'white' }}>
      <Container>
        <Toolbar disableGutters sx={{ justifyContent: 'space-between' }}>
          <Typography 
            variant="h6" 
            component={Link} 
            to="/"
            sx={{ 
              flexGrow: 0, 
              textDecoration: 'none',
              color: '#1565c0',
              fontWeight: 700,
              display: 'flex',
              alignItems: 'center'
            }}
          >
            VesselChain
          </Typography>
          
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {role === 'ADMIN' && (
              <Button 
                color="inherit" 
                component={Link} 
                to="/users"
                sx={{ 
                  mx: 1,
                  color: isActive('/users') ? '#1565c0' : '#555',
                  fontWeight: isActive('/users') ? 600 : 400,
                  borderBottom: isActive('/users') ? '2px solid #1565c0' : 'none',
                  borderRadius: 0,
                  padding: '6px 12px',
                  textTransform: 'none'
                }}
              >
                Users
              </Button>
            )}
            {role === 'SHIPOWNER' && (
              <>
                <Button 
                  color="inherit" 
                  component={Link} 
                  to="/vessels"
                  sx={{ 
                    mx: 1,
                    color: isActive('/vessels') ? '#1565c0' : '#555',
                    fontWeight: isActive('/vessels') ? 600 : 400,
                    borderBottom: isActive('/vessels') ? '2px solid #1565c0' : 'none',
                    borderRadius: 0,
                    padding: '6px 12px',
                    textTransform: 'none'
                  }}
                >
                  Vessels
                </Button>
                <Button 
                  color="inherit" 
                  component={Link} 
                  to="/bunkerings"
                  sx={{ 
                    mx: 1,
                    color: isActive('/bunkerings') ? '#1565c0' : '#555',
                    fontWeight: isActive('/bunkerings') ? 600 : 400,
                    borderBottom: isActive('/bunkerings') ? '2px solid #1565c0' : 'none',
                    borderRadius: 0,
                    padding: '6px 12px',
                    textTransform: 'none'
                  }}
                >
                  Bunkerings
                </Button>
                <Button 
                  color="inherit" 
                  component={Link} 
                  to="/bunkerings/new"
                  sx={{ 
                    mx: 1,
                    color: isActive('/bunkerings/new') ? '#1565c0' : '#555',
                    fontWeight: isActive('/bunkerings/new') ? 600 : 400,
                    borderBottom: isActive('/bunkerings/new') ? '2px solid #1565c0' : 'none',
                    borderRadius: 0,
                    padding: '6px 12px',
                    textTransform: 'none'
                  }}
                >
                  Upload BDN
                </Button>
                <Button 
                  color="inherit" 
                  component={Link} 
                  to="/permissions"
                  sx={{ 
                    mx: 1,
                    color: isActive('/permissions') ? '#1565c0' : '#555',
                    fontWeight: isActive('/permissions') ? 600 : 400,
                    borderBottom: isActive('/permissions') ? '2px solid #1565c0' : 'none',
                    borderRadius: 0,
                    padding: '6px 12px',
                    textTransform: 'none'
                  }}
                >
                  Permissions
                </Button>
              </>
            )}
            {role === 'SUPPLIER' && (
              <>
                <Button
                  color="inherit"
                  component={Link}
                  to="/supplier-vessels"
                  sx={{
                    mx: 1,
                    color: isActive('/supplier-vessels') ? '#1565c0' : '#555',
                    fontWeight: isActive('/supplier-vessels') ? 600 : 400,
                    borderBottom: isActive('/supplier-vessels') ? '2px solid #1565c0' : 'none',
                    borderRadius: 0,
                    padding: '6px 12px',
                    textTransform: 'none'
                  }}
                >
                  Vessels
                </Button>
                <Button
                  color="inherit"
                  component={Link}
                  to="/bunkerings"
                  sx={{
                    mx: 1,
                    color: isActive('/bunkerings') ? '#1565c0' : '#555',
                    fontWeight: isActive('/bunkerings') ? 600 : 400,
                    borderBottom: isActive('/bunkerings') ? '2px solid #1565c0' : 'none',
                    borderRadius: 0,
                    padding: '6px 12px',
                    textTransform: 'none'
                  }}
                >
                  Bunkerings
                </Button>
                <Button
                  color="inherit"
                  component={Link}
                  to="/bunkerings/new"
                  sx={{
                    mx: 1,
                    color: isActive('/bunkerings/new') ? '#1565c0' : '#555',
                    fontWeight: isActive('/bunkerings/new') ? 600 : 400,
                    borderBottom: isActive('/bunkerings/new') ? '2px solid #1565c0' : 'none',
                    borderRadius: 0,
                    padding: '6px 12px',
                    textTransform: 'none'
                  }}
                >
                  Upload BDN
                </Button>
              </>
            )}
            {role === 'VERIFIER' && (
              <>
                <Button
                  color="inherit"
                  component={Link}
                  to="/verifier-vessels"
                  sx={{
                    mx: 1,
                    color: isActive('/verifier-vessels') ? '#1565c0' : '#555',
                    fontWeight: isActive('/verifier-vessels') ? 600 : 400,
                    borderBottom: isActive('/verifier-vessels') ? '2px solid #1565c0' : 'none',
                    borderRadius: 0,
                    padding: '6px 12px',
                    textTransform: 'none'
                  }}
                >
                  Vessels
                </Button>
                <Button 
                  color="inherit" 
                  component={Link} 
                  to="/bunkerings"
                  sx={{ 
                    mx: 1,
                    color: isActive('/bunkerings') ? '#1565c0' : '#555',
                    fontWeight: isActive('/bunkerings') ? 600 : 400,
                    borderBottom: isActive('/bunkerings') ? '2px solid #1565c0' : 'none',
                    borderRadius: 0,
                    padding: '6px 12px',
                    textTransform: 'none'
                  }}
                >
                  Bunkerings
                </Button>
              </>
            )}
            {/* User menu: avatar + display name triggers dropdown */}
            <Box sx={{ ml: 3 }}>
              <Button
                id="user-menu-button"
                onClick={handleClick}
                startIcon={
                  <Avatar sx={{ bgcolor: getRoleColor(role), width: 32, height: 32 }}>
                    {getInitial(user.username)}
                  </Avatar>
                }
                endIcon={<AccountCircleIcon />}
                sx={{ textTransform: 'none', color: '#555' }}
              >
                {user.name}
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                MenuListProps={{ 'aria-labelledby': 'user-menu-button' }}
              >
                {role !== 'ADMIN' && (
                  <MenuItem component={Link} to="/profile" onClick={handleClose}>
                    <PersonIcon fontSize="small" sx={{ mr: 1 }} />
                    Update Profile
                  </MenuItem>
                )}
                <MenuItem component={Link} to="/change-password" onClick={handleClose}>
                  <KeyIcon fontSize="small" sx={{ mr: 1 }} />
                  Change Password
                </MenuItem>
                <MenuItem onClick={() => { handleClose(); logout(); }}>
                  <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
                  Logout
                </MenuItem>
              </Menu>
            </Box>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
